module.exports = __webpack_public_path__ + "img/id-card.6ad4043b.png";